module.exports = __webpack_public_path__ + "static/media/defaultImage.17e03819.png";